import { GetWpsTransactionsListResponse } from 'api/laborerPortalAPI/wps'
import { CallAPIAction, Status } from 'api/types'
import { convertTransactionFromResponse, Transaction } from 'common/utils/wpsConvertResponse'
import Actions from 'redux/actions'

type State = {
  data: Array<Transaction>
  lastPage: number
} & Status

const initialState: State = {
  data: [],
  lastPage: 0,
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.LABORER_GET_WPS_TRANSACTIONS_ASYNC,
    Actions.LABORER_GET_WPS_TRANSACTIONS_SUCCESS,
    Actions.LABORER_GET_WPS_TRANSACTIONS_FAIL,
    GetWpsTransactionsListResponse
  >,
) => {
  switch (action.type) {
    case Actions.LABORER_GET_WPS_TRANSACTIONS_FAIL:
    case Actions.LABORER_GET_WPS_TRANSACTIONS_ASYNC:
      return {
        ...state,
        ...action.status,
      }
    case Actions.LABORER_GET_WPS_TRANSACTIONS_SUCCESS: {
      return {
        ...state,
        ...action.status,
        data: action.payload.data.map(convertTransactionFromResponse),
        lastPage: action.payload.meta.last_page || 0,
      }
    }

    default:
      return state
  }
}
